export default function FooterBox() {
  return (
    <footer className="footer">
      <span>Copyright 2023. wazzang All rights reserved.</span>
    </footer>
  );
}
